import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import {Link} from 'react-router-dom';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  card: {
    'min-height': '300px',
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
      '&:hover': {
        transform: 'translateY(-5px)',
        'box-shadow': '0 10px 20px rgba(0,0,0,0.15)',
      }
  },
  onMouseEnter: {
    boxShadow: theme.shadows[6],
    maxWidth: 205,
    minWidth: 205,
    'min-height': '300px',
    borderRadius: '13px',
    transition: 'all 0.25s',
    transform: 'translateY(-5px)',
  },
  onMouseLeave: {
    maxWidth: 205,
    minWidth: 205,
    'min-height': '300px',
    boxShadow: theme.shadows[4],
    borderRadius: '13px',

  },
  CardActionArea: {
    alignItems: 'center',
  }

}));


const Wrapper = ({ children, link }) => {
  const isExternal = link.startsWith('http');
  
  if (isExternal) {
    return (
      <a 
        href={link} 
        target="_blank" 
        rel="noopener noreferrer" 
        style={{ textDecoration: 'none' }}
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={link} style={{ textDecoration: 'none' }}>
      {children}
    </Link>
  );
};

export default function ImgMediaCard2({text,imgPath,title,link}) {
  const classes = useStyles();
  const [mouse, setMouse] = React.useState(false);

  const onMouseEnter = () => {
    setMouse(!mouse)
  }

  const onMouseLeave = () => {
    setMouse(!mouse)
  }



  return (
    <Wrapper
      link={link}
      underline='none'
      style={{ textDecoration: 'none' }}
      onMouseEnter={() => onMouseEnter()}
      onMouseLeave={() => onMouseLeave()}
      >
        <Card
          className={clsx(classes.drawer, {
            [classes.onMouseEnter]: mouse,
            [classes.onMouseLeave]: !mouse,
          })}
          style={{
                  'backgroundImage' : `url(${imgPath})`,
                  'backgroundPosition': 'center',
                  'backgroundSize': 'cover',
                }}
          >

            <CardContent

              style={{
                'height': '150px'
              }}>
            </CardContent>
            <CardContent
              style={{
                color: 'white',
              }}>
              <Typography gutterBottom variant="h5" component="h2">
                {title}
              </Typography>
              <Typography variant="body2" component="p">
                {text}
              </Typography>
            </CardContent>
        </Card>
    </Wrapper>
  );
}
